import { render, staticRenderFns } from "./EmptyFooter.vue?vue&type=template&id=1c2af6db"
import script from "./EmptyFooter.vue?vue&type=script&lang=js"
export * from "./EmptyFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports